import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import {
	FooterContainer,
	FooterSubscription,
	FooterSubHeading,
	SocialMedia,
	SocialMediaWrap,
	SocialLogo,
	SocialIcon,
	WebsiteRights,
	SocialIcons,
	SocialIconLink,
} from './FooterStyles';

const Footer = () => {
	return (
		<FooterContainer>
			<FooterSubscription>
				<SocialLogo to="/">
					<SocialIcon src="./images/logo.svg" />
					ASTRO
				</SocialLogo>
				<FooterSubHeading>Interested working with me?</FooterSubHeading>
			</FooterSubscription>

			<SocialMedia>
				<SocialMediaWrap>
					<WebsiteRights>© Copyright 1337 ASTRO </WebsiteRights>
					<SocialIcons>
						<SocialIconLink href="https://github.com/a-str-o" target="blank" aria-label="github">
							<FaGithub />
						</SocialIconLink>
						<SocialIconLink href="https://www.linkedin.com/in/a-str-o/" target="blank" aria-label="Linkedin">
							<FaLinkedin />
						</SocialIconLink>
					</SocialIcons>
				</SocialMediaWrap>
			</SocialMedia>
		</FooterContainer>
	);
};

export default Footer;
